import { NamesOfFieldEnum, ConfigNamesFields, NamesOfFieldBankInfoEnum } from "~/typings/types";

export const configTitleFieldsOfSelfEmployed: ConfigNamesFields = {
  [NamesOfFieldEnum.OrgType]: "Самозанятый",
  [NamesOfFieldEnum.Name]: "ФИО",
  [NamesOfFieldEnum.Inn]: "ИНН",
  [NamesOfFieldEnum.Ogrn]: "ОГРН",
  [NamesOfFieldEnum.Ogrnip]: "Ogrnip",
  [NamesOfFieldEnum.Kpp]: "КПП",
  [NamesOfFieldEnum.BankName]: "Название банка",
  [NamesOfFieldEnum.SettlementAccount]: "Расчётный счёт",
  [NamesOfFieldEnum.CorrespondentAccount]: "Корреспондентский счёт",
  [NamesOfFieldEnum.BankBic]: "БИК",
  [NamesOfFieldEnum.LegalAddress]: "Адрес регистрации по паспорту",
  [NamesOfFieldEnum.PostalAddress]: "Почтовый адрес",
  [NamesOfFieldEnum.Vat]: "Являетесь ли плательщиком НДС?",
  [NamesOfFieldEnum.VatMode]: "Вы зарегистрированы как самозанятый?",
  [NamesOfFieldEnum.SignatureInfo]: "Должность и ФИО лица, подписывающего договор",
  [NamesOfFieldEnum.LprName]: "ФИО ЛПР",
  [NamesOfFieldEnum.LprPhone]: "Телефон ЛПР",
  [NamesOfFieldEnum.BuhName]: "ФИО бухгалтера",
  [NamesOfFieldEnum.BuhPhone]: "Телефон бухгалтера",
  [NamesOfFieldEnum.TechName]: "ФИО технического специалиста",
  [NamesOfFieldEnum.TechPhone]: "Телефон технического специалиста",
  [NamesOfFieldEnum.PayformPhone]: "Номер телефона для покупателей",
  [NamesOfFieldEnum.PayformEmail]: "Email",
  [NamesOfFieldEnum.PayformLinks]:
    "Ссылка на сайт или соцсеть с описанием Вашего сервиса и с которого проходят его продажи",
  [NamesOfFieldEnum.CrmName]: "ФИО",
  [NamesOfFieldEnum.CrmPhone]: "Мобильный телефон",
  [NamesOfFieldEnum.CrmEmail]: "E-mail",
  [NamesOfFieldEnum.CrmSocialLinks]: "Ссылка на профиль в соцсетях",
  [NamesOfFieldEnum.PaymentNotificationEmail]: "E-mail для уведомлений об оплате",
  [NamesOfFieldEnum.ProductType]: "Что будете продавать?",
  [NamesOfFieldEnum.ProductName]: "Универсальное название товара или услуги",
  [NamesOfFieldEnum.PayformName]: "Название платёжной страницы латиницей",
  [NamesOfFieldEnum.EducationalMaterialsPlatform]:
    "На какой платформе размещены учебные материалы и информация о ваших услугах?",
  [NamesOfFieldEnum.PayformPaymentMethods]:
    "Какие из перечисленных вариантов оплаты сделать доступными для ваших покупателей?",
  [NamesOfFieldEnum.ClientIntegrationInfo]:
    "Перечислите сервисы и платформы с которыми потребуются интеграции для осуществления продаж",
  [NamesOfFieldEnum.ShopName]: "Название магазина",
  [NamesOfFieldEnum.ProductDescription]: "Описание оказываемых услуг",
  [NamesOfFieldEnum.LogoFileId]: "Ваш логотип",
  [NamesOfFieldEnum.PassportFileId]: "Скан паспорта",
  [NamesOfFieldEnum.DocumentAgreement1FileId]: "Договор оказания услуг",
  [NamesOfFieldEnum.DocumentAgreement2FileId]: "Оферта",
  [NamesOfFieldEnum.ClientFrom]: "Откуда вы о нас узнали?",
  [NamesOfFieldEnum.ClientPromocode]: "Промокод",
  [NamesOfFieldEnum.ClientLengthOfService]: "Давно ли вы на рынке онлайн-образования?",
  [NamesOfFieldEnum.IsHaveEducationalLicense]: "Есть ли у вас образовательная лицензия?"
};

export const configTitleFieldsOfBank = {
  [NamesOfFieldBankInfoEnum.BankName]: "Название банка",
  [NamesOfFieldBankInfoEnum.BankInn]: "ИНН банка",
  [NamesOfFieldBankInfoEnum.BankBic]: "БИК банка",
  [NamesOfFieldBankInfoEnum.BankKpp]: "КПП банка",
  [NamesOfFieldBankInfoEnum.BankCorrespondentAccount]: "Корреспондентский счёт банка"
};